import { render, staticRenderFns } from "./ticket-detail.vue?vue&type=template&id=83265694&scoped=true&"
import script from "./ticket-detail.vue?vue&type=script&lang=ts&"
export * from "./ticket-detail.vue?vue&type=script&lang=ts&"
import style0 from "./ticket-detail.vue?vue&type=style&index=0&id=83265694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83265694",
  null
  
)

component.options.__file = "ticket-detail.vue"
export default component.exports